import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import './ForgotResetPage.scss'
import HeaderLogin from '../../Components/Commons/HeaderLogin'

class ForgotResetPage extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            input: {
                resetPassword: '',
                resetPasswordConfirm: '',
                email: '',
                password: '',
            },
            completeReset: false,
        }
    }

    resetPassword = (event) => {
        event.preventDefault()

        if (this.state.input.resetPassword === '') {
            alert('새 비밀번호를 입력해 주세요.')
            return
        } else if (this.state.input.resetPasswordConfirm === '') {
            alert('재확인 비밀번호를 입력해 주세요.')
            return
        } else if (this.state.input.resetPassword.length < 8 || this.state.input.resetPassword.length > 15) {
            alert('비밀번호는 8~15자리를 사용해야 합니다.')
            return
        } else if (this.state.input.resetPassword !== this.state.input.resetPasswordConfirm) {
            alert('비밀번호가 일치하지 않습니다.')
            return
        }

        axios
            .post(`${BACKEND_HOST}/auth/reset-password/${this.props.match.params.id}`, {
                password: this.state.input.resetPassword,
            })
            .then((res) => {
                console.log(res)
                this.setState({
                    completeReset: true,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    forgotLogin = (event) => {
        event.preventDefault()

        if (this.state.input.email === '') {
            alert('이메일을 입력해 주세요.')
            return
        } else if (this.state.input.password === '') {
            alert('비밀번호를 입력해 주세요.')
            return
        }
        const referrer = 'hausplanner'

        axios
            .post(`${BACKEND_HOST}/auth/login`, {
                email: this.state.input.email,
                password: this.state.input.password,
                referrer,
            })
            .then((res) => {
                Auth.authenticateUser(res.data.token)
                this.props.toggleAuthenticateStatus()

                const { cookies } = this.props
                const expire = new Date()
                expire.setDate(expire.getDate() + 365)
                cookies.set('demo', false, { path: '/', maxAge: 31536000, expires: expire })
                this.props.history.push('/project')
            })
            .catch((err) => {
                console.log(err)
                alert(
                    '아이디 또는 비밀번호를 다시 확인하세요. 등록되지 않은 아이디이거나, 아이디 또는 비밀번호를 잘못 입력하셨습니다.'
                )
            })
    }

    changeData = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    render() {
        console.log(this.state)

        //비번 길이 확인
        let passwordMsg = ''
        let passwordLength = false

        if (this.state.input.resetPassword !== '') {
            if (this.state.input.resetPassword.length < 8 || this.state.input.resetPassword.length > 15) {
                passwordMsg = '비밀번호는 8~15자리를 사용해야 합니다.'
                passwordLength = false
            } else {
                passwordMsg = '사용 가능한 비밀번호입니다.'
                passwordLength = true
            }
        }

        //비번 일치 확인
        let passwordConfirmMsg = ''
        let passwordConfirm = false

        if (this.state.input.resetPassword !== '' && this.state.input.resetPasswordConfirm !== '') {
            if (this.state.input.resetPassword !== this.state.input.resetPasswordConfirm) {
                passwordConfirmMsg = '비밀번호가 일치하지 않습니다.'
                passwordConfirm = false
            } else {
                passwordConfirmMsg = '비밀번호가 일치합니다.'
                passwordConfirm = true
            }
        }

        return (
            <div>
                <HeaderLogin />
                <div className="section_wrap">
                    <div className="forgot_reset_wrap common_detail">
                        <div className="forgot_section">
                            <div className="section_top">
                                <h1>비밀번호 변경</h1>
                            </div>
                            {this.state.completeReset ? (
                                <form
                                    className="section_bottom section_bottom_complete"
                                    action="/"
                                    onSubmit={this.forgotLogin}>
                                    <div className="complete_box">
                                        <p>
                                            정상적으로 <span>변경</span>되었습니다.
                                        </p>
                                        <p>
                                            변경된 비밀번호로 <span>앱</span>에서 로그인할 수 있습니다.
                                        </p>
                                    </div>
                                    <div className="input_wrap input_wrap1">
                                        <label>이메일</label>
                                        <input
                                            className="input"
                                            type="text"
                                            name="email"
                                            onChange={this.changeData}
                                            value={this.state.input.email}
                                        />
                                    </div>
                                    <div className="input_wrap">
                                        <label>비밀번호</label>
                                        <input
                                            className="input"
                                            type="password"
                                            name="password"
                                            onChange={this.changeData}
                                            value={this.state.input.password}
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        className={
                                            this.state.input.email !== '' && this.state.input.password !== ''
                                                ? 'full_btn_pc btn_active'
                                                : 'full_btn_pc'
                                        }>
                                        로그인
                                    </button>
                                </form>
                            ) : (
                                <form className="section_bottom" action="/" onSubmit={this.resetPassword}>
                                    <div className="input_wrap input_wrap1">
                                        <label>새 비밀번호</label>
                                        <input
                                            className="input"
                                            type="password"
                                            name="resetPassword"
                                            onChange={this.changeData}
                                            value={this.state.input.resetPassword}
                                        />
                                        <p className={`check_msg ${passwordLength && 'msg_on'}`}>{passwordMsg}</p>
                                    </div>
                                    <div className="input_wrap">
                                        <label>재확인</label>
                                        <input
                                            className="input"
                                            type="password"
                                            name="resetPasswordConfirm"
                                            onChange={this.changeData}
                                            value={this.state.input.resetPasswordConfirm}
                                        />
                                        <p className={`check_msg ${passwordConfirm && 'msg_on'}`}>
                                            {passwordConfirmMsg}
                                        </p>
                                    </div>
                                    <button
                                        type="submit"
                                        className={
                                            passwordLength && passwordConfirm ? 'full_btn_pc btn_active' : 'full_btn_pc'
                                        }>
                                        비밀번호 변경
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(ForgotResetPage)



// WEBPACK FOOTER //
// ./Src/Containers/User/ForgotResetPage.js